import { useEffect } from 'react';
import usePageTitle from '@hooks/usePageTitle/usePageTitle';
import { usePageContext } from '@providers/PageMetaProvider/model/PageContext';
import MainCard from '@components/ui/cards/MainCard';
import SettingsFirmProfileForm from '@features/settings-firm-profile/containers/SettingsFirmProfileForm';

const pageValues = {
  title: 'Firm Profile',
  description: 'Letterhead and signature printed on your demand letters',
};

function SettingsFirmProfilePage() {
  usePageTitle('ZlaytAI - Firm Profile');
  const { setValues } = usePageContext();

  useEffect(() => {
    if (setValues) {
      setValues((prev) => ({
        ...prev,
        ...pageValues,
      }));
    }
  }, []);

  return (
    <MainCard>
      <SettingsFirmProfileForm />
    </MainCard>
  );
}

export default SettingsFirmProfilePage;
